export const C = {
  ink: "#12262B",
  text: "#1B2533",
  muted: "#1B2533",
  faint: "#2A3846",
  teal: "#15A08C",
  tealD: "#0F8474",
  tealInk: "#0E8A78",
  tealSoft: "#E3F4F0",
  line: "#E7EAF0",
  lineSoft: "#F1F3F7",
  surface: "#F4F6F8",
  amber: "#B7791F",
  amberSoft: "#FBF1DD",
  green: "#1F9D6B",
  greenSoft: "#E4F5EC",
  red: "#C5483B",
  redSoft: "#FBE9E7",
  blue: "#3B6CB3",
  blueSoft: "#E7F0FB",
} as const;

export const FONT = "Inter, system-ui, sans-serif";